import { ISSUED_APP_STATUSES } from "@/helpers/applicationStatusGroups"

export const createdAppDataLocalStore = "create-application-data"
export const createdProjectId = "created-project-id"
export const pageModeKey = "page-mode"
export const createdProjectCategory = "created-project-category"
export const createAppMapSnapshot = "create-application-map-snapshot"
export const DateFormat = "DD MMM YYYY"
export const StrapiDateFormat = "YYYY-MM-DD"
export const StrapiDateTimeFormat = "YYYY-MM-DDTHH:mm:ssZ"
export const longDash = "—"
export const squareSymbol = "²"

export const APPLICATION_PROGRESS = {
  created: 5,
  documents_uploaded: 15,
  paid: 15,
  ready_for_submitting: 20,
  on_review: 25,
  reviewed: 30,
  submitted: 35,
}

export const approvedStatuses = [
  "approvals_in_process",
  ...ISSUED_APP_STATUSES,
  "in_construction",
  "outside_service_area",
  "submitted",
]

export const uploadedDocExtensions = ".jpg,.jpeg,.png,.pdf,.tif,.tiff,.doc,.docx,.kml,.kmz,.geojson,.json"
export const allowedExtensions = [
  ".jpg",
  ".jpeg",
  ".png",
  ".pdf",
  ".tif",
  ".tiff",
  ".doc",
  ".docx",
  ".kml",
  ".kmz",
  ".geojson",
  ".json",
]
export const allowedTypes = [
  "image/jpeg", // .jpg, .jpeg
  "image/png", // .png
  "application/pdf", // .pdf
  "image/tiff", // .tif, .tiff
  "application/msword", // .doc
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
  "application/vnd.google-earth.kml+xml", // .kml
  "application/geo+json", // .geojson
  "application/json", // .json / .geojson
]
